import React, { useState, useEffect } from 'react';
import FilterColumn from '../FilterColumn';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
import { TicketButton, NextButton, StyledInput } from '../../Common/MUIStyledComponents';
import Modal from 'react-modal';
import DataSearchAPI from 'api/DataSearch';
import { useSnackbar } from 'notistack';
import { Grid, Card } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import { CardActions } from '@mui/material';
import SelectionsBadge from '../SelectionsBadge';
import { Pagination } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface IFilterOptions {
  setFilterMode: any;
  lensOpts: any;
  countryOpts: any;
  agencyOpts: any;
  listOpts: any;
  totalRecords: number;
  setSubmit: any;
  submit: any;
  commodityState: any;
  setCommodityState: any;
  handleClear: any;
  inputs: any;
  appliedFilter: any;
  setAppliedFilter: any;
  countOpts: string[];
  agOpts: string[];
  filters: any;
  setFilters: any;
  cur_user: any;
}

const CommodityListFilterOptions: React.FC<IFilterOptions> = ({ inputs, commodityState, setCommodityState, setFilterMode, lensOpts, countryOpts, agencyOpts, listOpts, totalRecords, setSubmit, submit, handleClear, appliedFilter, setAppliedFilter, countOpts, agOpts, filters, setFilters, cur_user }) => {
  const { comLenses, countries, agencies, lists } = commodityState;

  const { enqueueSnackbar } = useSnackbar();

  const [ tab, setTab ] = useState('Selections');
  const [ filterName, setFilterName ] = useState<string>('');
  const [ filterNameOpen, setFilterNameOpen ] = useState(false);
  const [ pageCount, setPageCount ] = useState<number>(0);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const resultsPerPage = 6;

  const handlePageChange = (e: any, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = new_page * resultsPerPage;
    const indexOfFirstItem = indexOfLastItem - resultsPerPage;


    setCurrentItems(filters.arr.slice(indexOfFirstItem, indexOfLastItem));
  };

  const handleFilterNameChange = (e: any) => {
    setFilterName(e.target.value);
  };

  const handleFilterNameClose = () => {
    setFilterNameOpen(false);
    setFilterName('');
  };

  const handleApply = () => {
    setSubmit({
      trigger: !submit.trigger,
      reason: 'apply',
      location: 'Commodity'
    });
    setFilterMode(false);
  };

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'Selections':
      setTab('Selections');
      break;
    case 'Saved':
      setTab('Saved');
      break;
    default:
      setTab('Selections');
    }
  };


  const saveListFilter = async() => {
    const query = {
      userId: cur_user.basics.id,
      groupId: cur_user.selected_team.id,
      filterName: filterName,
      type: 'commodityList',
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      entRes: commodityState.fuzzy,
    };
    const res = await DataSearchAPI.createSearchFilter({ newSearchFilter: query });
    if (res?.success) {
      setFilters({ isLoaded: true, arr: [ ...filters.arr, res?.result ] });
      setAppliedFilter(res?.result);
      setTab('Saved');
      enqueueSnackbar('Successfully saved your filter', { variant: 'success' });
    } else if (res) {
      const error_msg = 'Error saving your filter, please try again or contact the bite team if the issue persist.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const updateFilter = async() => {
    setFilters({ ...filters, isLoaded: false });
    const query = {
      ...appliedFilter,
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      entRes: commodityState.fuzzy,
    };
    const res = await DataSearchAPI.updateSearchFilter({ update: query });
    if (res?.success) {
      const index = filters.arr.map((filt: any, i: number) => {
        if (filt._id === res.result._id) {
          return i;
        }
      });
      const array = [ ...filters.arr ];
      array[index[0]] = res.result;
      setFilters({ isLoaded: true, arr: array });
      enqueueSnackbar('Successfully updated your filter', { variant: 'success' });
    } else {
      const error_msg = 'Error updating your filter, please try again or contact the bite team if the issue persist.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const deleteFitler = async(id: string) => {
    const res = await DataSearchAPI.deleteSearchFilter(id);
    if (res?.success) {
      const arr = filters.arr.filter((filt: any) => {
        return filt._id !== id;
      });
      setFilters({ isLoaded: true, arr: arr });
    }
  };

  const applyListFilter = async(filter: any) => {
    setCommodityState({
      ...commodityState,
      comLenses: filter.lenses,
      countries: filter.countries,
      agencies: filter.agencies,
      lists: filter.lists,
      fuzzy: filter.entRes,
    });
    setSubmit({ reason: 'apply', trigger: !submit.trigger });
    setAppliedFilter(filter);
    setFilterMode(false);
  };

  useEffect(() => {
    const indexOfLastItem = currentPage * resultsPerPage;
    const indexOfFirstItem = indexOfLastItem - resultsPerPage;
    setCurrentItems(filters.arr.slice(indexOfFirstItem, indexOfLastItem));
    const totalPages = Math.ceil(filters.arr.length / resultsPerPage);
    if (totalPages === 0) {
      setPageCount(1);
    } else {
      setPageCount(totalPages);
    }
  }, [ filters ]);

  return (
    <div className='filter-options-container'>
      <div className='filter-options-header'>
        <div className='filter-options-header-content'>
          <div className='filter-options-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M6 12H18M3 6H21M9 18H15' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='filter-options-header-text-group'>
            <div className='filter-options-header-text-primary'>
              {Object.keys(appliedFilter).length > 1 ? appliedFilter.filterName : 'Listing Filter'}
            </div>
            <div className='filter-options-header-inputs-frame'>
              <div className='filter-options-header-inputs-primary'>
                Current Search: &nbsp;
              </div>
              {inputs.length > 0 && inputs[0].primary !== '' ? (
                <div className='filter-options-header-inputs-secondary'>
                  {inputs.map((input: any) => (
                    `${input.primary }, `
                  ))
                  }
                </div>
              ) : (
                <div className='filter-options-header-inputs-secondary'>
                N/A
                </div>
              )}
            </div>
            <div className='filter-options-header-text-secondary'>
              {totalRecords} records found
            </div>
          </div>
        </div>
        <div className='filter-options-header-close' onClick={() => setFilterMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='filter-modal-tabs-container'>
        <div className='screening-tabs-inner'>
          <div
            className={`screening-tab-btn${tab === 'Selections' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Selections')}
          >
            <div
              className={`screening-tab-btn-text${tab === 'Selections' ? '-selected' : ''
              }`}
            >
              Selections
            </div>
          </div>
          <div
            className={`screening-tab-btn${tab === 'Saved' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Saved')}
          >
            <div
              className={`screening-tab-btn-text${tab === 'Saved' ? '-selected' : ''
              }`}
            >
              Saved Filters
            </div>
          </div>
        </div>
      </div>
      {tab === 'Selections' ?
        <>
          <div className='filter-options-body-container'>
            {/* Lenses */}
            <FilterColumn location='Commodity' state={commodityState} type={'comLenses'} selections={comLenses} setSelections={setCommodityState} options={lensOpts.data} title='Lens' setSubmit={setSubmit} submit={submit} loading={false} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M16.5616 11.5058C14.4443 13.0121 11.6671 13.1794 9.40777 12M2.43833 6.49417C4.56079 4.98425 7.34633 4.81978 9.60862 6.00862M12.0303 10.5933C14.1953 9.22876 15.4489 6.7306 15.2007 4.13417M6.93638 7.42778C4.79174 8.79682 3.55219 11.2827 3.79908 13.8658M12.1452 7.60278C12.0454 5.04638 10.5087 2.71263 8.13658 1.62917M6.85671 10.4442C6.97334 12.9822 8.50571 15.294 10.8633 16.3708M14.8033 3.6967C17.7322 6.62563 17.7322 11.3744 14.8033 14.3033C11.8744 17.2322 7.12562 17.2322 4.1967 14.3033C1.26777 11.3744 1.26777 6.62562 4.1967 3.6967C7.12563 0.767767 11.8744 0.767767 14.8033 3.6967ZM11.6213 6.87868C12.7929 8.05025 12.7929 9.94975 11.6213 11.1213C10.4497 12.2929 8.55025 12.2929 7.37868 11.1213C6.20711 9.94975 6.20711 8.05025 7.37868 6.87868C8.55025 5.70711 10.4497 5.70711 11.6213 6.87868Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'countries'} selections={countries} setSelections={setCommodityState} options={countryOpts.data} loading={countryOpts.isLoading} title='Country Regulator' setSubmit={setSubmit} submit={submit} countOpts={countOpts}
              icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
                <path d='M10.5 5.62478L8.25 7.87478L11.25 9.37478L9 11.6248M15.75 8.99978C15.75 12.6811 11.7345 15.3586 10.2735 16.2109C10.1074 16.3078 10.0244 16.3562 9.90726 16.3814C9.81633 16.4009 9.68367 16.4009 9.59274 16.3814C9.47557 16.3562 9.39255 16.3078 9.22651 16.2109C7.76547 15.3586 3.75 12.6811 3.75 8.99978V5.41298C3.75 4.81335 3.75 4.51353 3.84807 4.25581C3.93471 4.02814 4.07549 3.82499 4.25824 3.66393C4.46512 3.48161 4.74585 3.37634 5.3073 3.16579L9.32865 1.65779C9.48457 1.59932 9.56253 1.57008 9.64274 1.55849C9.71388 1.54821 9.78612 1.54821 9.85726 1.55849C9.93747 1.57008 10.0154 1.59932 10.1713 1.65779L14.1927 3.16579C14.7542 3.37634 15.0349 3.48161 15.2418 3.66393C15.4245 3.82499 15.5653 4.02814 15.6519 4.25581C15.75 4.51353 15.75 4.81335 15.75 5.41298V8.99978Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'agencies'} selections={agencies} setSelections={setCommodityState} options={agencyOpts.data} loading={agencyOpts.isLoading} title='Agency' setSubmit={setSubmit} submit={submit} agOpts={agOpts} icon={<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
              <path d='M3.75 6.75026V12.7503M7.125 6.75026V12.7503M10.875 6.75026V12.7503M14.25 6.75026V12.7503M2.25 13.9503L2.25 14.5503C2.25 14.9703 2.25 15.1803 2.33175 15.3408C2.40365 15.4819 2.51839 15.5966 2.65951 15.6685C2.81994 15.7503 3.02996 15.7503 3.45 15.7503H14.55C14.97 15.7503 15.1801 15.7503 15.3405 15.6685C15.4816 15.5966 15.5963 15.4819 15.6683 15.3408C15.75 15.1803 15.75 14.9703 15.75 14.5503V13.9503C15.75 13.5302 15.75 13.3202 15.6683 13.1598C15.5963 13.0186 15.4816 12.9039 15.3405 12.832C15.1801 12.7503 14.97 12.7503 14.55 12.7503H3.45C3.02996 12.7503 2.81994 12.7503 2.65951 12.832C2.51839 12.9039 2.40365 13.0186 2.33175 13.1598C2.25 13.3202 2.25 13.5302 2.25 13.9503ZM8.73968 2.30811L3.18968 3.54144C2.85439 3.61595 2.68674 3.65321 2.5616 3.74336C2.45122 3.82288 2.36455 3.93093 2.31086 4.05593C2.25 4.19765 2.25 4.36939 2.25 4.71286L2.25 5.55026C2.25 5.9703 2.25 6.18032 2.33175 6.34075C2.40365 6.48187 2.51839 6.59661 2.65951 6.66851C2.81994 6.75026 3.02996 6.75026 3.45 6.75026H14.55C14.97 6.75026 15.1801 6.75026 15.3405 6.66851C15.4816 6.59661 15.5963 6.48187 15.6683 6.34075C15.75 6.18032 15.75 5.9703 15.75 5.55026V4.71287C15.75 4.36939 15.75 4.19765 15.6891 4.05593C15.6355 3.93093 15.5488 3.82288 15.4384 3.74336C15.3133 3.65321 15.1456 3.61595 14.8103 3.54144L9.26032 2.30811C9.16317 2.28652 9.1146 2.27573 9.06552 2.27142C9.02192 2.2676 8.97808 2.2676 8.93448 2.27142C8.8854 2.27573 8.83683 2.28652 8.73968 2.30811Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
            <FilterColumn location='Commodity' state={commodityState} type={'lists'} selections={lists} setSelections={setCommodityState} options={listOpts.data} loading={listOpts.isLoading} title='List' setSubmit={setSubmit} submit={submit} icon={<svg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'>
              <path d='M16 2.25H2.5M16 15.75H2.5M4 9C4 8.30109 4 7.95163 4.11418 7.67598C4.26642 7.30843 4.55843 7.01642 4.92598 6.86418C5.20163 6.75 5.55109 6.75 6.25 6.75L12.25 6.75C12.9489 6.75 13.2984 6.75 13.574 6.86418C13.9416 7.01642 14.2336 7.30843 14.3858 7.67598C14.5 7.95163 14.5 8.30109 14.5 9C14.5 9.69891 14.5 10.0484 14.3858 10.324C14.2336 10.6916 13.9416 10.9836 13.574 11.1358C13.2984 11.25 12.9489 11.25 12.25 11.25L6.25 11.25C5.55109 11.25 5.20163 11.25 4.92597 11.1358C4.55843 10.9836 4.26642 10.6916 4.11418 10.324C4 10.0484 4 9.69891 4 9Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>}
            />
          </div>
          <div className='filter-options-btns-container'>
            <div className='filter-options-btns-spacer'>
              {Object.keys(appliedFilter).length > 1 && <Button sx={{ color: '#4895EF', marginLeft: '20px' }} onClick={() => {
                updateFilter();
              }}>Update Saved Filter</Button>}
              <Button
                disabled={commodityState.comLenses.length === 0 && commodityState.countries.length === 0 && commodityState.agencies.length === 0 && commodityState.lists.length === 0}
                sx={{ color: '#4895EF', marginLeft: '20px' }}
                onClick={() => setFilterNameOpen(true)}
              >Save Filter</Button>
              <Button
                onClick={() => {
                  handleClear();
                }}
                sx={{ color: '#EFF1F6' }}>Clear</Button>
              <Button
                sx={{ color: '#EFF1F6', background: '#4895EF' }}
                onClick={handleApply}
              >Apply</Button>
            </div>
          </div>
        </> :
        <>
          <div className='saved-filters-container'>
            {filters.arr.length === 0 ?
              <div className='no-saved-filters-row'>
                <div className='no-saved-filters-text'>
                   You have no saved Listing Filters
                </div>
              </div> :
              <Grid container spacing={2} sx={{ padding: '20px' }}>
                {currentItems.map((filt: any) =>
                  <Grid item xs={12} sm={6} md={4} key={filt._id}>
                    <Card variant='outlined' sx={{ background: appliedFilter._id === filt._id ? 'rgba(72, 149, 239, 0.15)' : '#2E3036',
                      border: appliedFilter._id === filt._id ? '1px solid #4895ef' : '1px solid transparent', borderRadius: '12px', fontFamily: 'Inter', fontSize: '18px', fontStyle: 'normal', color: '#EFF1F6', display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                      <React.Fragment>
                        <CardContent>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontFamily: 'Inter', fontSize: '18px', fontStyle: 'normal', color: '#EFF1F6', fontWeight: 600 }} component='div' noWrap>
                              {filt.filterName}
                            </Typography>
                            <DeleteOutlineIcon onClick={() => deleteFitler(filt._id)} sx={{ color: '#BDBEC1', cursor: 'pointer' }} />
                          </div>
                          <Typography sx={{ display: 'flex', gap: '12px', fontFamily: 'Inter', fontStyle: 'normal', color: '#EFF1F6', }}>Selected Lists: <SelectionsBadge selections={filt.lists} />
                          </Typography>
                          <Typography variant='body2' sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontFamily: 'Inter', fontStyle: 'normal', color: '#EFF1F6',
                          }}>
                          Lenses: {filt.lenses.length > 0 ? filt.lenses.join(', ') : ''}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          {appliedFilter._id !== filt._id && <Button onClick={() => applyListFilter(filt)} size='small'>Apply Filter</Button>}
                        </CardActions>
                      </React.Fragment>
                    </Card>
                  </Grid>
                )}
              </Grid>
            }
            <div className='screening-results-footer'>
              <div className='screening-results-pagination-text'>
                Page {currentPage} of {pageCount}
              </div>
              <div className='screening-results-footer-action-group'>
                <div className='hb-pagination'>
                  <Pagination
                    onChange={handlePageChange}
                    size='large'
                    count={pageCount}
                    shape='rounded'
                    variant='text'
                    page={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      }
      <Modal
        isOpen={filterNameOpen}
        onRequestClose={handleFilterNameClose}
        ariaHideApp={false}
      >
        <div className='bite-score-file-modal'>
          <div className='display-flex justify-between width-100'>
            <Typography variant='h5'>Filter Name:</Typography>
            <TicketButton onClick={handleFilterNameClose} className='cursor-pointer'/>
          </div>
          <div className='display-flex justify-end width-100'>
            <StyledInput
              value={filterName}
              onChange={handleFilterNameChange}
              variant='outlined'
              className='margin-right-20px'
            />
            <NextButton variant='contained' color='primary'
              onClick={() => {
                saveListFilter();
                handleFilterNameClose();
              }
              }>Save</NextButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CommodityListFilterOptions;
